import { render, staticRenderFns } from "./QAMatchingTest.vue?vue&type=template&id=1fbcfec8&scoped=true&"
import script from "./QAMatchingTest.vue?vue&type=script&lang=js&"
export * from "./QAMatchingTest.vue?vue&type=script&lang=js&"
import style0 from "./QAMatchingTest.vue?vue&type=style&index=0&id=1fbcfec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcfec8",
  null
  
)

export default component.exports